module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit4-1-904fc9e2f7adf8e0f3198aa0ec3dd44c.png";